import { Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ClientCar } from 'src/typings';
import { ClientService } from '../client.service';
export const CLIENT_CAR_DIALOG_CONFIG: MatDialogConfig = { width: '620px', maxWidth: 'calc(100vw - 24px)', maxHeight: 'calc(100dvh - 24px)', panelClass: 'client-edit-dialog', autoFocus: false };
@Component({ selector: 'app-create-car', templateUrl: './create-car.component.html', styleUrls: ['./create-car.component.scss'] })
export class CreateCarComponent {
  constructor(private fb: UntypedFormBuilder, private clientService: ClientService, @Optional() private dialogRef?: MatDialogRef<CreateCarComponent>) {}
  @Input() clientId?: number;
  @Input() carId?: number;
  @Output() createCarEvent = new EventEmitter<ClientCar>();
  saving = false;
  error = '';
  createForm: UntypedFormGroup = this.fb.group({ vin: new UntypedFormControl(), description: new UntypedFormControl() });
  get vin() { return this.createForm.value.vin; }
  get description() { return this.createForm.value.description; }
  get vinControl() { return this.createForm.controls.vin; }
  get descriptionControl() { return this.createForm.controls.description; }
  close() { if (!this.saving) this.dialogRef?.close(); }
  async submit() {
    if (this.saving || (!this.clientId && this.carId) || (!this.clientId && !this.vin?.trim() && !this.description?.trim())) return;
    this.saving = true; this.error = '';
    if (this.dialogRef) this.dialogRef.disableClose = true;
    try {
      const payload = { vin: this.vin, description: this.description, client_id: this.clientId };
      const car = this.carId ? (await firstValueFrom(this.clientService.updateClientCar({ ...payload, id: this.carId })))[0][0] : await firstValueFrom(this.clientService.createClientCar(payload));
      this.createCarEvent.emit(car);
    } catch { this.error = 'Не удалось сохранить автомобиль. Проверьте данные и повторите.'; }
    finally { this.saving = false; if (this.dialogRef) this.dialogRef.disableClose = false; }
  }
}
